<template>
  <div class="filter w-100">
    <h4 v-show="filter.favorite">{{ $t(title) }}</h4>
    <div v-show="!filter.favorite" class="title" @click="display=!display">{{ $t(title) }} {{ (counter ? " ( " + counter + " ) " : "") }}
      <help-tooltip v-if="$t(filter.help_text_i18n)" :tooltip-text="$t(filter.help_text_i18n)"></help-tooltip>
      <div class="dots">•••</div>
    </div>
    <div v-show="display">
      <component :is=activeFilter v-bind=options track-by="value" label="name_i18n" v-model="filterValue" @updatevalues="updateValues"
                 :placeholder="filter.placeholder_i18n ? $t(filter.placeholder_i18n) : $t(title)"
                 :select-label="$t('filters.select')"
                 @change="manualSetFilter"
                 @input="setFilter"
                 @mousedown.native="lockRequestSending($event)"
                 @mouseup.native="unlockRequestSending($event)"
      >
        <template slot="placeholder">
          <span class="">{{ filter.placeholder_i18n ? $t(filter.placeholder_i18n) : $t(title)}}</span>
        </template>
        <template slot="option" slot-scope="props">
            <span class="option__title">{{ props.option.name_i18n ? $t(props.option.name_i18n) : props.option.name }}</span>
        </template>
        <template slot="tag" slot-scope="{ option, remove }">
          <span class="multiselect__tag">
            <span>{{ option.name_i18n ? $t(option.name_i18n) : option.name }}</span>
            <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
          </span>
        </template>
      </component>
      <div class="filter-footer" v-if="footer.min || footer.max">
        <span class="start-range-title">{{ footer.min }}{{ filter.label.start_i18n ? $t(filter.label.start_i18n) : filter.label.start }}</span>
        <span class="end-range-title">{{ footer.max }}{{ filter.label.end_i18n ? $t(filter.label.end_i18n) : filter.label.end }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import VueSlider from 'vue-slider-component'
import Multiselect from 'vue-multiselect'
import {BFormCheckbox} from 'bootstrap-vue'
import moneyMixin from '../mixins/money'
import TwoRangeInputs from '@/components/TwoRangeInputs'
import TwoRangeDatePickers from '@/components/TwoRangeDatePickers'
import YesNoSelectors from '@/components/YesNoSelectors'
import HelpTooltip from '@/components/HelpTooltip'

export default {
  name: 'Filter-Block',
  props: ['filter', 'defaultValue', 'defaultDisplay', 'useEnabledFilters'],
  mixins: [moneyMixin],
  components: {HelpTooltip, TwoRangeInputs, TwoRangeDatePickers, YesNoSelectors, Multiselect, BFormCheckbox},
  data()
  {
    return {
      activeFilter: null,
      options: [],
      filterValue: null,
      title: '',
      counter: 0,
      footer: {},
      display: this.defaultDisplay ? true : !this.filter.advanced,
      allowedFilters: null,
      requestLocked: false,
      isRangeDotClicked: false
    }
  },
  created()
  {
    this.$root.$on('resetLockRequest', () =>
    {
      this.requestLocked = false
    })
  },
  mounted()
  {
    this.allowedFilters = this.$store.getters['filters/getListOfFilters'](this.$router.currentRoute.path)
    this.showFilter()
    document.addEventListener('mouseup', this)
  },
  watch: {
    '$store.state.filters.setDefaultFilterValue': {
      handler(setDefaultFilterValue)
      {
        setDefaultFilterValue.forEach(function (defaultFilterValues)
            {
              if (defaultFilterValues.id === this.filter.id)
              {
                this.filterValue = defaultFilterValues.values
                this.$emit('set-filter', {id: this.filter.id, values: defaultFilterValues.values})
                // this.setFilter(defaultFilterValues)
                this.counter = 0
              }
            }
            , this)
      },
      deep: true
    },
    '$store.state.filters.enabledFilters': {
      handler(enabledFilters)
      {
        const filter = (enabledFilters ?? []).find(filter => filter.id === this.filter.id)

        if (filter)
        {
          this.filterValue = filter.values
          this.$nextTick(this.setCounter())
        }
        else
        {
          this.counter = 0
        }
      },
      deep: true,
      immediate: true
    },
    '$store.state.filters.enabledCustomFilters': {
      handler(enabledCustomFilters)
      {
          try
          {
            if (enabledCustomFilters[0]) {
              const customFilter = enabledCustomFilters[0] // only one custom filter!
              if (customFilter.filters)
              {
                customFilter.filters.forEach(function (filter)
                {
                  const resultFilter = {
                    id: filter.id,
                    values: filter.values
                  }
                  // debugger
                  // console.log(resultFilter)
                  if (parseInt(resultFilter.id) === parseInt(this.filter.id))
                  {
                    switch (this.filter.type)
                    {
                      case 'range':
                        resultFilter.values = [
                          parseFloat(filter.values[0]),
                          parseFloat(filter.values[1])
                        ]
                        break
                      case 'multiselect':
                        resultFilter.values = filter.values
                        break
                      case 'boolean':
                        resultFilter.values = filter.values[0] // TODO need to check. Now we don't have boolean elements
                        break
                    }
                    this.filterValue = resultFilter.values
                    this.setFilter(resultFilter, null, false)
                  }
                }, this)
              }
            }
          }
          catch (e)
          {
            console.log('Problems with applying of enabled filters ', e)
          }
      },
      deep: true
    }
  },
  methods: {
    // ...
    handleEvent(event) {
      switch (event.type) {
        case 'mouseup':
          // Fix for DEV-951 Increase/decrease component bug in UI
          // event.preventDefault()
          if (this.isRangeDotClicked)
          {
            this.unlockAndSend(event)
          }
          break
      }
    },
    unlockAndSend(e) {
        this.requestLocked = false
        if (e && e.target && e.target.getAttribute('class'))
        {
          if (e.target.getAttribute('class') === 'vue-slider-dot-handle vue-slider-dot-handle-focus')
          {
            return // <-- disable duplicate request to count filters if user clicked on range dot
          }
        }
        this.sendFilters()
        this.requestLocked = true
        this.isRangeDotClicked = false
    },
    sendFilters()
    {
      const f = document.getElementById(this.$props.filter.id)
      if (f && f.childNodes[0])
      {
        const min = f.childNodes[0].childNodes[1].getAttribute('aria-valuenow')
        const max = f.childNodes[0].childNodes[2].getAttribute('aria-valuenow')
        // console.log('send after unlock values: [min, max]', [min, max])
        this.$emit('set-filter', {id: this.$props.filter.id, values: [parseFloat(min), parseFloat(max)]})
      }
    },
    lockRequestSending(e)
    {
      if (e && e.target && e.target.getAttribute('class'))
      {
        if (e.target.getAttribute('class') === 'vue-slider-dot-handle vue-slider-dot-handle-focus')
        {
          // Detect click on SLIDER dot!
          this.isRangeDotClicked = true
        }
      }
      // console.log('TODO Lock request!')
      this.requestLocked = true
    },
    unlockRequestSending(event)
    {
      // console.log(event.target.getAttribute('style') ? 'click' : 'slide')
      // console.log('TODO UnLock request!')
      try
      {
        // Additional check only for range clicked or slide range: if style than only clicked(skip this) else set filter
        if (this.$props.filter.type === 'range' && !event.target.getAttribute('style')) {
          this.sendFilters()
        }
      } catch (e)
      {
        console.error('Problem with unlock Request Sending:', e)
      }
      this.requestLocked = false
    },
    showFilter()
    {
      try
      {
        const filter = this.allowedFilters.find(f => f.id === this.filter.id)
        const enabledFilters = this.$store.getters['filters/getEnabledFilters']
        this.title = filter.name
        if (filter.name_i18n) {
          this.title = filter.name_i18n
        }
        if (filter.placeholder_i18n) {
          filter.placeholder = this.$t(filter.placeholder_i18n)
        }
        filter.multiple = Boolean(filter.multiple)
        filter.taggable = Boolean(filter.taggable)
        switch (filter.type)
        {
          case 'range':
            this.activeFilter = 'VueSlider'
            this.options = filter
            this.filterValue = this.defaultValue ?? filter.range
            // eslint-disable-next-line no-case-declarations
            let min = filter.min
            // eslint-disable-next-line no-case-declarations
            let max = filter.max
            filter.interval = parseFloat(filter.interval)
            if (filter.money)
            {
              min = this.$options.filters.moneyFormatter(filter.min)
              max = this.$options.filters.moneyFormatter(filter.max)
            }
            this.footer.min = min
            this.footer.max = max
            break
          case 'multiselect':
            this.activeFilter = 'Multiselect'
            this.options = filter
            this.filterValue = this.defaultValue
            break
          case 'boolean':
            filter.id = filter.id.toString()
            this.activeFilter = 'BFormCheckbox'
            this.options = filter
            this.filterValue = this.defaultValue
            break
          case 'date_range':
            this.activeFilter = 'TwoRangeDatePickers'
            this.options = filter.options
            this.filterValue = this.defaultValue
            break
          case 'text_range':
            this.activeFilter = 'TwoRangeInputs'
            this.options = filter.options
            this.filterValue = this.defaultValue
            break
          case 'text':
            filter.id = filter.id.toString()
            this.activeFilter = 'BFormInput'
            this.options = filter
            this.filterValue = this.defaultValue
            break
          case 'yes_no':
            filter.id = filter.id.toString()
            this.activeFilter = 'YesNoSelectors'
            this.options = filter
            this.filterValue = this.defaultValue
            break
          case 'allowed_not':
            filter.id = filter.id.toString()
            this.activeFilter = 'YesNoSelectors'
            this.options = filter
            this.filterValue = filter.default_values ?? this.defaultValue
            break
        }

        if (this.defaultValue || filter.type === 'boolean')
        {
          this.setCounter()
          this.updateValues(this.defaultValue)
        }
      }
      catch (e)
      {
        console.log('Problems with display of filter ' + this.filter.id, e)
      }
    },
    manualSetFilter(value, additional = false, sendRequest = true)
    {
      // console.log('manualSetFilter run!')
      this.$root.$emit('resetInvestFilters')
      this.setFilter(value, additional, sendRequest)
    },
    setFilter(value, additional = false, sendRequest = true)
    {
      // console.log('Changed:', this.$props.filter.id, value, this.requestLocked)
      this.$store.dispatch('filters/updateSendRequest', sendRequest)
      this.setCounter()
      if (!this.requestLocked)
      {
        this.$emit('set-filter', {id: this.$props.filter.id, values: value})
      }
    },
    setCounter()
    {
      const filter = (this.allowedFilters ?? []).find(f => f.id === this.filter.id)
      if (['multiselect'].includes(filter?.type))
      {
        this.counter = this.filterValue ? (Array.isArray(this.filterValue) ? this.filterValue.length : 0) : 0
      }
      else
      {
        this.counter = 0
      }
    },
    updateValues(values)
    {
      this.filterValue = values
      this.$emit('set-filter', {id: this.$props.filter.id, values: values})
    }
  },
  beforeDestroy()
  {
    document.removeEventListener('mouseup', this)
  }
}
</script>

<style lang="scss">
.multiselect__tag,
.multiselect__option--highlight,
.multiselect__option--highlight:after{
  background: #30A7FE !important;
}
.filter {
  //border-bottom: 1px solid #E5E9ED;
  display: inline-block;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #000000;
    margin-bottom: 16px;
    margin-top: 15px;
    cursor: pointer;
  }

  .dots {
    float: right;
  }

  hr {
    background: #E5E9ED;
  }
}

.end-range-title {
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #000000;
}

.start-range-title {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
}
</style>
